import * as XLSX from 'xlsx';
import dayjs from 'dayjs';
import { getGoodFromLabel, getPartyDisplayName, getPoOrChallanDisplay } from '../../utility/goodsReceiveDisplay';

const DownloadGoodsReceiveExcel = (receiveList, companyName, setOpenBackdrop) => {
    if (!receiveList || receiveList.length === 0) {
        alert("No data found to export!");
        return;
    }

    setOpenBackdrop(true);

    try {
        const rows = [];

        const headers = [
            "GRN No",
            "Good From",
            "Supplier / Customer",
            "PO No / Challan No",
            "Bill No",
            "Location",
            "Received By",
            "Received Date",
            "Approved Status"
        ];
        rows.push(headers);

        receiveList.forEach((receipt) => {
            const safeGrn = receipt.grn_no || 'N/A';
            const safeGoodFrom = getGoodFromLabel(receipt);
            const safeParty = getPartyDisplayName(receipt);
            const safePoOrChallan = getPoOrChallanDisplay(receipt);
            const safeBillNo = receipt.purchase_bill_no || 'N/A';
            const safeLocation = receipt.location_address || 'N/A';
            const safeReceivedBy = receipt.staff_name || 'N/A';
            const dateValue = receipt.billing_date;
            const safeDate = dateValue && dayjs(dateValue).isValid() ? dayjs(dateValue).format("DD/MM/YYYY") : 'N/A';
            const safeApproved = receipt.is_approved || receipt.approved_status || 'N/A';
            rows.push([
                safeGrn,
                safeGoodFrom,
                safeParty,
                safePoOrChallan,
                safeBillNo,
                safeLocation,
                safeReceivedBy,
                safeDate,
                safeApproved
            ]);
        });

        const worksheet = XLSX.utils.aoa_to_sheet(rows);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Goods Receive");

        worksheet['!cols'] = [
            { wch: 15 }, { wch: 12 }, { wch: 22 }, { wch: 18 },
            { wch: 15 }, { wch: 20 }, { wch: 18 }, { wch: 15 }, { wch: 15 },
        ];

        XLSX.writeFile(workbook, `Goods_Receive_${new Date().getTime()}.xlsx`);
    } catch (error) {
        console.error("Excel Error:", error);
        alert("Error generating Excel!");
    } finally {
        setOpenBackdrop(false);
    }
};

export default DownloadGoodsReceiveExcel;
